import { theme } from "@/core/theme";

/**
 * Shop layout breakpoints (min-width). Responsive arrays with three entries map as:
 * index 0 — below 1152px (mobile)
 * index 1 — 1152px–1399px (tablet)
 * index 2 — 1400px and up (desktop)
 */
export const SHOP_BREAKPOINTS = ["1152px", "1400px"];
SHOP_BREAKPOINTS.sm = SHOP_BREAKPOINTS[0];
SHOP_BREAKPOINTS.md = SHOP_BREAKPOINTS[1];
SHOP_BREAKPOINTS.lg = SHOP_BREAKPOINTS[1];

export const shopTheme = {
  ...theme,
  breakpoints: SHOP_BREAKPOINTS,
  mediaQueries: {
    small: `@media screen and (min-width: ${SHOP_BREAKPOINTS.sm})`,
    medium: `@media screen and (min-width: ${SHOP_BREAKPOINTS.md})`,
    large: `@media screen and (min-width: ${SHOP_BREAKPOINTS.lg})`
  }
};
